import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Card, CardBody, CardTitle, Col, Container, Row } from 'reactstrap';
import POSExcelImport from './POSExcelImportNew';

const UploadExcelNew = ({ dispatch, vendor }) => {
  const { t } = useTranslation('common');
  const location = useLocation();
  const navigate = useNavigate();

  const skuOption = [];
  const productNameOptions = [];

  return (
    <Container>
      <Card className="pb-3">
        <CardBody className="dashboard__card-widget card-shadow p-3">
          <CardTitle className="bold-text text-center" tag="h3">
            Upload New Point Of Sales
          </CardTitle>          
        </CardBody>
      </Card>
      <Row className="product-table-wrap">        
          <Col sm="12">
            <CardBody>   
                <POSExcelImport navigate={navigate} />          
            </CardBody>
          </Col>     

      </Row>
    </Container>
  )
};

UploadExcelNew.propTypes = {
  dispatch: PropTypes.func.isRequired,
  vendor: PropTypes.number.isRequired
}

export default connect(state => ({
  rtl: state.rtl,
}))(UploadExcelNew);